export const MIN_CARDS = 1
export const MAX_CARDS = 3
export const DEFAULT_CARD_COUNT = 3

export const createDefaultCard = () => ({
    image: '',
    imageAlt: '',
    title: '',
    copy: '',
    linkText: '',
    linkUrl: '',
    openInNewTab: false,
})
